import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

export default function Hidden({
    children,
    only,
    xsUp,
    xsDown,
    smUp,
    smDown,
    mdUp,
    mdDown,
    lgUp,
    lgDown,
    xlUp,
    xlDown
}) {
    const theme = useTheme();

    const isXsUp = useMediaQuery(theme.breakpoints.up('xs'));
    const isXsDown = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
    const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
    const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
    const isXlUp = useMediaQuery(theme.breakpoints.up('xl'));
    const isXlDown = useMediaQuery(theme.breakpoints.down('xl'));

    const isOnlyXs = useMediaQuery(theme.breakpoints.only('xs'));
    const isOnlySm = useMediaQuery(theme.breakpoints.only('sm'));
    const isOnlyMd = useMediaQuery(theme.breakpoints.only('md'));
    const isOnlyLg = useMediaQuery(theme.breakpoints.only('lg'));
    const isOnlyXl = useMediaQuery(theme.breakpoints.only('xl'));

    if (only) {
        const onlyKeys = Array.isArray(only) ? only : [only];
        const onlyMatches = { xs: isOnlyXs, sm: isOnlySm, md: isOnlyMd, lg: isOnlyLg, xl: isOnlyXl };
        if (onlyKeys.some((key) => onlyMatches[key])) {
            return null;
        }
    }

    if (xsUp && isXsUp) return null;
    if (xsDown && isXsDown) return null;
    if (smUp && isSmUp) return null;
    if (smDown && isSmDown) return null;
    if (mdUp && isMdUp) return null;
    if (mdDown && isMdDown) return null;
    if (lgUp && isLgUp) return null;
    if (lgDown && isLgDown) return null;
    if (xlUp && isXlUp) return null;
    if (xlDown && isXlDown) return null;

    return <>{children}</>;
}
